import { useIdentityRoles } from '@/js/libs/use-auth';

export const useNavigationComponentsVisibilityChecks = () => {
  const { POSTNETZ_BRANCH_USER, READ_ONLY_POSTNETZ_BRANCH_USER, POSTADMANAGER, YALEO_SELF_BOOKING, ADMIN, SWITCH_COMPANY_VIEW } =
    useIdentityRoles();
  return {
    isGlobalSearchVisible: ADMIN || (!POSTNETZ_BRANCH_USER && !READ_ONLY_POSTNETZ_BRANCH_USER && !POSTADMANAGER && !YALEO_SELF_BOOKING),
    isCompanySwitchVisible: !!SWITCH_COMPANY_VIEW,
  };
};
